export function getKeyFromItem<Item extends { value: unknown }>(item: Item, index: number) {
  const value = item.value;
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  return index;
}

export function filterItemStartsWith<Item extends { label: string }>(inputValue: string, item: Item): boolean {
  return item.label.toLocaleLowerCase().startsWith(inputValue.toLocaleLowerCase());
}
